<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10ALgwl/tc-custom/9781644577653.jpg?1729379729270" alt="This image is the cover for the book Seven Reasons Your Church Will Never Have Revival"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Seven Reasons Your Church Will Never Have Revival
      </h1>
      <p class="bookDescription body article font2">
        <b>Looking To Be Part of the Final Move of God? Discover Why Many Are Missing the Mighty Revival Currently Sweeping the Globe.</b><br/><br/>Arm yourself with the tools necessary to experience a spiritual awakening. This book was written for pastors and evangelists by Jonathan Shuttlesworth, both an evangelist and pastor of Revival Today Church. He identifies the roadblocks preventing churches from experiencing revival and pens an unfiltered message rooted in God’s Word that convicts, inspires, and leads to self-reflection for church leaders and evangelists alike. This book will equip you with the strategies necessary to usher revival, empower you to remove barriers to revival, and motivate you to overcome challenges that prohibit you from experiencing a move of God.<br/><br/><b>You’ll Learn To:</b><br/>• Identify what revival is, what it is not, and how to achieve it.<br/>• Pinpoint hindrances and pitfalls that discourage the move of The Holy Spirit.<br/>• Challenge the status quo, combat stagnancy, and ditch rituals steeped in tradition and religion.<br/>• Take actions necessary to welcome revival and rapid church growth.<br/>• Embrace evangelistic ministry within your church.<br/><br/><b>A Message from the Author:</b> <br/>This book may not have the most uplifting title, but its message is crucial. Revival isn’t something you beg for—it’s something you facilitate by removing obstacles. Jesus rebuked the Pharisees and Sadducees for their stifling structures, not the sinners of society. Today, many churches have unknowingly erected similar barriers, preventing the Spirit of God from moving. I aim to help you identify and dismantle these barriers to foster an environment where revival can thrive. The battles I’ve faced, the lessons I’ve learned, and the victories I’ve achieved are laid out in this book to guide you toward success.<br/><br/><b>About the Author:</b> <br/>Jonathan Shuttlesworth is an evangelist and founder of Revival Today, a global ministry dedicated to reaching lost and hurting people with the Gospel of Jesus Christ. He is also the pastor of Revival Today Church, a Holy Spirit-filled, Bible-believing church in Pittsburgh, PA, and Forth Worth, TX, that blesses families and the nation.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jonathan Shuttlesworth
      </h2>
      
      <p class="authorDescription body article">Jonathan Shuttlesworth is an evangelist and founder of Revival Today, a global ministry dedicated to reaching lost and hurting people with the Gospel of Jesus Christ. He is also the pastor of Revival Today Church, a Holy Spirit-filled, Bible-believing church that blesses families and the nation.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Rise UP Publications
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?72ab243e